import Dexie from 'dexie';

export const db = new Dexie('azn-attendee-app');

db.version(4).stores({
  attendees: '++ref, type, f, l, j, o, a, seq'
});